import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-data-surface',

  imports: [CommonModule],
  templateUrl: './data-surface.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './data-surface.component.scss',
})
export class DataSurfaceComponent {
  flush = input(false);
}
